module.exports = __webpack_public_path__ + "static/media/verified.d1826015.png";